import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'
import loadPages from 'utils/loadPages'
import { getCustomData } from 'shared/components/App/Auth'
import Store from 'redux/Store'
import { setMenuPages } from 'shared/redux/actions'
import { setLastUrl } from 'shared/redux/actions'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
  extraData: any
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const formData = {
    ...props.data,
    icon: props.data.icon.id ?? '',
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      setFormValidationError(err, props.setError, undefined, 'name')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    const pageIds: Array<number> = props.extraData.pages.map((p) => p.page_id)
    response = await axiosPost(apiUrls.sections, formData, catchFunc).then((data) => {
      if (data?.status !== undefined && data.status === 201) {
        pageIds.forEach((pageId) => {
          axiosPost(
            apiUrls.sectionsToPages,
            {
              page_id: pageId,
              section_id: data.data.id,
            },
            catchFunc,
          )
        })
      }
      return data
    })
  } else {
    response = await axiosPut(apiUrls.sections + '/' + props.id, formData, catchFunc)
  }

  // reload stored pages
  if ((response.status === 200) || (response.status === 201)) {
    loadPages({
      role: getCustomData('role'),
      customer: getCustomData('customer') ?? false,
      loadFromServer: true
    }).then((pages) => {
      Store.dispatch(setMenuPages(pages))

      // if last viewed page no longer in menu, find a new one
      const lastUrl = Store.getState()?.lastUrl.lastUrl

      const curPage = pages.find((item) => {
        return item.path === lastUrl['user']
      })
      if (typeof curPage === 'undefined') {
        const newLastPage = pages.find((item) => {
          // find where item.roles has 'user'
          return item.roles?.includes('user') && (item?.isDropdown !== true)
        })
        
        if (newLastPage) {
          lastUrl['user'] = newLastPage.path
        }
        else {
          lastUrl['user'] = '/'
        }
        Store.dispatch(setLastUrl(lastUrl))
      }
      
    })
  }

  return response
}

export default submitForm
